import { Outlet } from "react-router-dom"
import { useFirebase } from "../providers/FirebaseProvider";
import { AuthPage } from "./pages/AuthPage";

export const Root = () => {
    const { isUserSignedIn } = useFirebase();

    return (
        <div className="bg-gradient-to-b from-gray-100 to-gray-200 shadow-inner h-screen">
            {isUserSignedIn() ? (<Outlet/>) : <AuthPage/>}
        </div>
    )
}